import { Component, Input } from '@angular/core';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dynamic-form-input-textarea',
  standalone: false,
  templateUrl: './dynamic-form-input-textarea.component.html',
  styleUrl: './dynamic-form-input-textarea.component.scss'
})
export class DynamicFormInputTextareaComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;
}
